import React from "react";
import __ from "src/utils/Translations";
import TransHtml from "src/Components/TransHtml";

export const getPositionsImportInstructions = (): React.ReactNode[] => [
  <TransHtml text="Pierwszy wiersz pełni funkcję nagłówka, a <b>import danych rozpoczyna się od drugiego wiersza.</b> Zawartość pierwszego wiersza nie jest przetwarzana." />,
  <TransHtml text="Każdy wiersz w pliku <b>powinien zawierać dokładnie 1 kolumnę.</b>" />,
  <TransHtml text="<b>Import służy wyłącznie do dodawania nowych stanowisk</b> - nie można przez niego edytować istniejących wpisów. <b>Edycja odbywa się ręcznie przez panel administracyjny.</b>" />,
  <TransHtml text="Stanowiska, których nazwa pokrywa się z już istniejącą pozycją w słowniku (z pominięciem wielkości liter i zbędnych spacji), zostaną pominięte z informacją." />,
  <TransHtml text="<b>Możesz skorzystać z gotowego szablonu</b> z nazwami kolumn lub wyeksportować aktualną listę stanowisk." />,
  <TransHtml text="Oczekiwany format plików to <b>CSV UTF-8 rozdzielany średnikami lub XLSX</b>" />,
];
